import React from 'react';

import { PlainTextHeader } from '../HeaderComponents/PlainTextHeader';

export const ReviewsExploreHeader = () => <PlainTextHeader mb={1}>My reviews</PlainTextHeader>;
